<template>
  <div class="width-100 position_relative flex-column justify-content-start align-items-center" style="min-height: 100%">
    <div class="width-90 paddingLr90" style="margin-top: 2vh">
      <div
        :class="{ 'from-right1': animation2 }"
        class="width-100 flex-row justify-content-spaceBetween align-items-center border-b textAlign-l fw-mid"
      >
        <p class="tit textAlign-c fs-sBig lineHeight2">党群活动</p>
        <p class="fs-sml fw-sml darkgrey pointer" @click="jump('/news?Id=2')">更多</p>
      </div>
      <div class="width-100 flex-row justify-content-spaceBetween align-items-star" style="margin-bottom: 2vh; margin-top: 1vh">
        <div :class="{ 'from-right2': animation2 }" class="width-50">
          <div
            @click="newsDetail(item.id, 'news')"
            v-for="(item, index) in partyEventList"
            :key="index"
            class="width-100 lineHeight2 flex-row justify-content-spaceBetween align-items-center pointer"
          >
            <p class="fs-big textAlign-l cutText black width-80">{{ item.title }}</p>
            <p class="fs-big darkgrey width-20">{{ item.createTime.substring(0, 10) }}</p>
          </div>
        </div>
        <div v-if="partyEventList.length > 0" :class="{ 'from-right3': animation2 }" class="width-50">
          <div @click="newsDetail(partyEventList[0].id, 'news')" class="mainBox pointer main1 flex-row justify-content-start align-items-center">
            <van-image :src="imagePrefix + partyEventList[0].poster" width="35%" class="van-overflow-hidden height120 margin-r" alt="" />
            <p class="fs-big width-60 white lineHeight1 fw-mid cutText3 textAlign-l margin-r">
              {{ partyEventList[0].title }}
            </p>
          </div>
          <div @click="newsDetail(partyEventList[1].id, 'news')" class="mainBox pointer main2 flex-row justify-content-start align-items-center">
            <p class="fs-big width-60 white lineHeight1 fw-mid cutText3 textAlign-l margin-l">
              {{ partyEventList[1].title }}
            </p>
            <van-image :src="imagePrefix + partyEventList[1].poster" width="35%" class="van-overflow-hidden height120 margin-l" alt="" />
          </div>
        </div>
      </div>
      <div
        :class="{ 'from-right4': animation2 }"
        class="margin-bottom20 width-100 flex-row justify-content-spaceBetween align-items-center border-b textAlign-l fw-mid"
        style=""
      >
        <p class="tit textAlign-c fs-sBig lineHeight2">专题专栏</p>
        <!--        <p class='fs-sml fw-sml darkgrey'>更多</p>-->
      </div>
      <!--      轮播-->
      <template v-if="swiperFlag" class="width-100">
        <div class="block width-100">
          <el-carousel indicator-position="none" :loop="true" :interval="3000" class="width-100 height150 hideysco">
            <el-carousel-item v-for="(item, index) in typeList.slice(0, typeList.length - 2)" :key="index">
              <van-image
                :class="{ 'from-right5': animation2 }"
                v-for="(eleItem, eleIndex) in typeList.slice(index, index + 4)"
                :key="eleIndex"
                width="24%"
                style="margin-right: 1%"
                @click="jumpTo('/project', eleItem)"
                :src="imagePrefix + eleItem.poster"
                alt=""
                class="pointer height150"
              ></van-image>
              <img
                v-if="index === typeList.length - 3"
                :class="{ 'from-right5': animation2 }"
                class="pointer height150"
                width="24%"
                @click="jump('/projectList')"
                src="@/assets/image/b4.jpg"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
      <div v-if="!swiperFlag" class="flex-row justify-content-spaceBetween align-items-star width-100">
        <van-image
          :class="{ 'from-right5': animation2 }"
          v-for="(item, index) in typeList"
          :key="index"
          width="24%"
          height="150px"
          @click="jumpTo('/project', item)"
          :src="imagePrefix + item.poster"
          alt=""
          class="pointer"
        ></van-image>
        <img
          :class="{ 'from-right5': animation2 }"
          class="pointer"
          width="24%"
          height="150px"
          @click="jump('/projectList')"
          src="@/assets/image/b4.jpg"
          alt=""
        />
      </div>

      <div :class="{ 'from-bottom03': animation2 }" class="width-100 margin-ts margin-bs flex-column justify-content-start align-items-center">
        <p class="darkgrey fs-sml lineHeight2">版权所有©国有资产投资集团有限公司</p>
        <div class="flex-row justify-content-center align-items-center">
          <img src="@/assets/image/icon.png" class="height18" alt="" />
          <p @click="jump('https://beian.miit.gov.cn/')" class="darkgrey fs-sml lineHeight2 margin-ls pointer">
            浙公网安备33038102331093 浙ICP备13003470号-1
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import newsApi from '@/api/newsApi';
import config from '@/config';

export default {
  name: 'page5',
  components: {},
  props: {
    animation2: Boolean
  },
  data() {
    return {
      imagePrefix: config.IMAGE_PREFIX,
      typeList: [],
      partyEventList: [],
      swiperFlag: false
    };
  },
  created() {
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 7, likeType: '010' } })
      .then((res) => {
        this.partyEventList = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .listType({ isProject: '1' })
      .then((res) => {
        if (res.data.length > 3) {
          this.swiperFlag = true;
        }
        this.typeList = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {},
  methods: {
    jumpTo(url, item) {
      if (null !== item && item.indexBannerUrl !== null) {
        window.open(item.indexBannerUrl, '_blank');
      } else {
        this.$router.push({ path: url, query: { id: item.id } });
      }
    },
    jump(url) {
      window.open(url, '_blank');
    },
    newsDetail(id, type) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: type, newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 50px;
}
.height18 {
  height: 18px;
}
.height120 {
  height: 120px;
}
.height70 {
  height: 70px;
}
.height150 {
  height: 180px;
}
.margin-top40 {
  margin-top: 40px;
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
}
.tit {
  border-bottom: 3px solid rgb(11, 73, 158);
  width: 90px;
}
.mainBox {
  height: 120px;
  overflow: hidden;
}
.main1 {
  background: rgb(11, 73, 158);
}
.main2 {
  background: rgb(26, 96, 192);
}
//.arrow {
//  margin: 100px 48.5% 0 !important;
//}
.fixed_r {
  top: 60%;
}
.from-right1 {
  position: relative;
  animation: right 0.5s 0s ease-in-out;
  -moz-animation: right 0.5s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 0.5s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 0.5s 0s ease-in-out; /* Opera */
}
.from-right2 {
  position: relative;
  animation: right 0.8s 0s ease-in-out;
  -moz-animation: right 0.8s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 0.8s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 0.8s 0s ease-in-out; /* Opera */
}
.from-right3 {
  position: relative;
  animation: right 1s 0s ease-in-out;
  -moz-animation: right 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 1s 0s ease-in-out; /* Opera */
}
.from-right4 {
  position: relative;
  animation: right 1.2s 0s ease-in-out;
  -moz-animation: right 1.2s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 1.2s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 1.2s 0s ease-in-out; /* Opera */
}
.from-right5 {
  position: relative;
  animation: right 1.5s 0s ease-in-out;
  -moz-animation: right 1.5s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 1.5s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 1.5s 0s ease-in-out; /* Opera */
}
@keyframes right {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-moz-keyframes right /* Firefox */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-webkit-keyframes right /* Safari and Chrome */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-o-keyframes right /* Opera */ {
  0% {
    right: -1000px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}
.from-bottom1 {
  position: relative;
  animation: bottom 1s 0s ease-in-out;
  -moz-animation: bottom 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 1s 0s ease-in-out; /* Opera */
}
@keyframes bottom {
  0% {
    bottom: -500px;
  }
  100% {
    bottom: 0;
  }
}

@-moz-keyframes bottom /* Firefox */ {
  0% {
    bottom: -500px;
  }
  100% {
    bottom: 0;
  }
}

@-webkit-keyframes bottom /* Safari and Chrome */ {
  0% {
    bottom: -500px;
  }
  100% {
    bottom: 0;
  }
}

@-o-keyframes bottom /* Opera */ {
  0% {
    bottom: -500px;
  }
  100% {
    bottom: 0;
  }
}
.from-bottom2 {
  position: relative;
  animation: bottom 1.2s 0s ease-in-out;
  -moz-animation: bottom 1.2s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 1.2s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 1.2s 0s ease-in-out; /* Opera */
}
.from-bottom3 {
  animation: bottom3 2s 0s ease-in-out;
  -moz-animation: bottom3 2s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom3 2s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom3 2s 0s ease-in-out; /* Opera */
}
@keyframes bottom3 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes bottom3 /* Firefox */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes bottom3 /* Safari and Chrome */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes bottom3 /* Opera */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.from-bottom1 {
  position: relative;
  animation: bottom 0.5s 0s ease-in-out;
  -moz-animation: bottom 0.5s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 0.5s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 0.5s 0s ease-in-out; /* Opera */
}
@keyframes bottom {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-moz-keyframes bottom /* Firefox */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-webkit-keyframes bottom /* Safari and Chrome */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}

@-o-keyframes bottom /* Opera */ {
  0% {
    bottom: -500px;
  }
  50% {
    bottom: 20px;
  }
  100% {
    bottom: 0;
  }
}
.from-bottom2 {
  position: relative;
  animation: bottom 0.8s 0s ease-in-out;
  -moz-animation: bottom 0.8s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 0.8s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 0.8s 0s ease-in-out; /* Opera */
}
.from-bottom3 {
  position: relative;
  animation: bottom 1s 0s ease-in-out;
  -moz-animation: bottom 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 1s 0s ease-in-out; /* Opera */
}
.from-bottom4 {
  position: relative;
  animation: bottom 1.3s 0s ease-in-out;
  -moz-animation: bottom 1.3s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom 1.3s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom 1.3s 0s ease-in-out; /* Opera */
}
.decsBox {
  top: 50px;
  left: 53%;
}

.from-bottom03 {
  animation: bottom03 2s 0s ease-in-out;
  -moz-animation: bottom03 2s 0s ease-in-out; /* Firefox */
  -webkit-animation: bottom03 2s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: bottom03 2s 0s ease-in-out; /* Opera */
}
@keyframes bottom03 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes bottom03 /* Firefox */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes bottom03 /* Safari and Chrome */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes bottom03 /* Opera */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style>
.el-carousel__item {
  line-height: 150px;
}
</style>
